import { Button, Select } from 'semantic-ui-react';
import { selectArea } from 'src/components/helpers';
import { habeasData } from 'src/components/helpers/habeasData';
import { hasFormErrors, yesNoValue } from 'src/containers/comunidad-network/form/networkFormUtils';

const FormIssue = ({ errorInputs }) =>
  hasFormErrors(errorInputs) ? (
    <h4 className="form-error">Por favor verifica los campos obligatorios en rojo.</h4>
  ) : null;

const SubmitButton = ({ sending, lookingUp, onSubmit, label = 'Enviar', sendingLabel = 'Enviando...' }) => (
  <Button type="button" onClick={onSubmit} primary disabled={sending || lookingUp}>
    {sending ? sendingLabel : label}
  </Button>
);

export const NetworkFormCreateActions = ({ errorInputs, sending, lookingUp, onSubmit }) => (
  <div className="actions">
    {habeasData}
    <FormIssue errorInputs={errorInputs} />
    <div className="actions__buttons">
      <SubmitButton sending={sending} lookingUp={lookingUp} onSubmit={onSubmit} />
    </div>
  </div>
);

export const NetworkFormEditActions = ({
  inputs,
  errorInputs,
  sending,
  selectHandle,
  onClose,
  onDiscard,
  onSubmit,
}) => (
  <div className="actions">
    <div className="published-field">
      <p>Publicado</p>
      {selectArea({
        Select,
        options: ['Seleccione', 'Si', 'No'],
        label: 'Publicado',
        name: 'published',
        value: yesNoValue(inputs.published),
        errorInputs,
        handler: selectHandle,
        selectOnBlur: false,
      })}
    </div>
    <FormIssue errorInputs={errorInputs} />
    <div className="actions__buttons">
      <Button type="button" onClick={onClose} secondary className="cancel" disabled={sending}>
        Cerrar
      </Button>
      {onDiscard && (
        <Button type="button" onClick={onDiscard} negative basic disabled={sending}>
          Descartar cambios
        </Button>
      )}
      <SubmitButton
        sending={sending}
        onSubmit={onSubmit}
        label="Confirmar cambios"
        sendingLabel="Confirmando..."
      />
    </div>
  </div>
);
